(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ink-color-family-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var input = document.querySelector('[data-ink-guide-search]');
      if (!input || input.dataset.inkGuideReady) return;
      input.dataset.inkGuideReady = 'true';

      var status = document.querySelector('[data-ink-guide-status]');
      var empty = document.querySelector('[data-ink-guide-empty]');
      var filterWrap = document.querySelector('[data-ink-guide-filters]');
      var selects = Array.prototype.slice.call(document.querySelectorAll('[data-ink-guide-filter]'));
      var clearButton = document.querySelector('[data-ink-guide-clear]');
      var BLANK = '__blank__';
      var ORDER = { transitioned: ['NEW', 'YES', 'NO'] };

      function allRows() {
        return document.querySelectorAll('[data-ink-guide-row]');
      }

      // Build each dropdown from the rows on the page, so new blocks show up without code changes.
      function buildOptions() {
        var rows = allRows();
        selects.forEach(function (select) {
          var key = select.dataset.inkGuideFilter;
          var counts = {};
          rows.forEach(function (row) {
            var value = row.dataset[key] || BLANK;
            counts[value] = (counts[value] || 0) + 1;
          });
          var order = ORDER[key] || [];
          Object.keys(counts)
            .sort(function (a, b) {
              if (a === BLANK) return 1;
              if (b === BLANK) return -1;
              var ia = order.indexOf(a);
              var ib = order.indexOf(b);
              if (ia !== -1 || ib !== -1) return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
              return a.localeCompare(b);
            })
            .forEach(function (value) {
              var option = document.createElement('option');
              option.value = value;
              option.textContent = (value === BLANK ? 'Not listed' : value) + ' (' + counts[value] + ')';
              select.appendChild(option);
            });
        });
        if (filterWrap && selects.length) filterWrap.hidden = false;
      }

      function filter() {
        var term = input.value.trim().toLowerCase();
        var rows = allRows();
        var shown = 0;
        var active = selects.filter(function (select) {
          return select.value !== '';
        });

        rows.forEach(function (row) {
          var match = !term || row.textContent.toLowerCase().indexOf(term) !== -1;
          if (match) {
            match = active.every(function (select) {
              return (row.dataset[select.dataset.inkGuideFilter] || BLANK) === select.value;
            });
          }
          row.hidden = !match;
          if (match) shown++;
        });

        document.querySelectorAll('[data-ink-guide-family]').forEach(function (family) {
          family.hidden = !family.querySelector('[data-ink-guide-row]:not([hidden])');
        });

        document.querySelectorAll('.ink-guide__table').forEach(function (table) {
          table.hidden = !table.querySelector('[data-ink-guide-row]:not([hidden])');
        });

        var filtering = term !== '' || active.length > 0;
        if (empty) empty.hidden = shown !== 0;
        if (status) status.textContent = filtering ? 'Showing ' + shown + ' of ' + rows.length + ' inks' : '';
        if (clearButton) clearButton.hidden = !filtering;
      }

      buildOptions();
      filter();

      input.addEventListener('input', filter);
      selects.forEach(function (select) {
        select.addEventListener('change', filter);
      });

      if (clearButton) {
        clearButton.addEventListener('click', function () {
          input.value = '';
          selects.forEach(function (select) {
            select.value = '';
          });
          filter();
          input.focus();
        });
      }
    }

    // Keep sticky table headers below the sticky site header.
    function updateStickyTop() {
      var header = document.querySelector('.site-header');
      var top = 0;
      if (header) {
        var position = window.getComputedStyle(header).position;
        if (position === 'fixed' || position === 'sticky') {
          top = Math.max(0, header.getBoundingClientRect().bottom);
        }
      }
      document.querySelectorAll('.ink-guide').forEach(function (guide) {
        guide.style.setProperty('--ink-guide-sticky-top', top + 'px');
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateStickyTop();
        ticking = false;
      });
    }

    // The page stacks two guide sections (50 families each). Join their tables into one,
    // so there is a single header row and it stays stuck to the top all the way down.
    // Skipped in the theme editor, where each section must keep its own blocks.
    function mergeTables() {
      if (window.Shopify && window.Shopify.designMode) return;
      var tables = document.querySelectorAll('.ink-guide__table');
      if (tables.length < 2) return;
      var first = tables[0];
      for (var i = 1; i < tables.length; i++) {
        Array.prototype.slice.call(tables[i].tBodies).forEach(function (body) {
          first.appendChild(body);
        });
        tables[i].remove();
      }
    }

    function boot() {
      mergeTables();
      init();
      updateStickyTop();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-modern"]) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
